import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navigation-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      class: "zamg-text-label ml-4 zamg-button",
      variant: "text",
      elevation: "0",
      "data-testid": "stepper-abort",
      disabled: _ctx.hideAbort,
      onClick: _ctx.emitAbort
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('abort')), 1)
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    _createVNode(_component_v_btn, {
      class: "zamg-text-label ml-4 zamg-button",
      variant: "text",
      elevation: "0",
      "data-testid": "stepper-previous",
      disabled: _ctx.hidePrevious,
      onClick: _ctx.emitPrevious
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('previous')), 1)
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    _createVNode(_component_v_btn, {
      class: "zamg-text-label ml-4 zamg-button",
      variant: "text",
      elevation: "0",
      "data-testid": "stepper-next",
      disabled: !_ctx.allowNext || _ctx.hideNext,
      onClick: _ctx.emitNext
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('next')), 1)
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}